import React from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalFooter,
  Button,
  ModalCloseButton,
  Box,
  Text,
} from '@chakra-ui/react'
import StatusIcon from '../ChangePassword/StatusIcon'
import { REPOSITORY } from '../../api/repository/Repository'
import { useNavigate } from 'react-router-dom'
import { useAuthDispatch } from '../../utils/login'

const ChangePasswordPopup = ({ isOpen, onClose, status }) => {
  const dispatch = useAuthDispatch()
  const navigate = useNavigate()

  const onLoggout = () => {
    REPOSITORY.local.company.eraseData()
    dispatch({ type: 'LOGOUT' })
    navigate('/login')
  }

  const handleButtonClick = () => {
    if (status === 'success') {
      onLoggout()
    } else {
      onClose()
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xs">
      <ModalOverlay />
      <ModalContent
        width="344px"
        height="282px"
        flexShrink={0}
        borderRadius="8px"
        background="var(--Gris-050, #EEE)"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        <ModalCloseButton />
        <ModalBody
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          gap="19px"
          textAlign="center"
        >
          <Box
            width="99.629px"
            height="105px"
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <StatusIcon status={status} />
          </Box>
          <Box
            width="312px"
            height="59px"
            display="flex"
            alignItems="center"
            justifyContent="center"
            textAlign="center"
            flexShrink={0}
          >
            <Text>
              {status === 'success' ? (
                <>
                  La clave fue actualizada. <br />
                  Se cerrará la sesión para que puedas <br />
                  ingresar nuevamente con la nueva <br />
                  clave.
                </>
              ) : (
                <>
                  Usuario o contraseña incorrecta.
                  <br />
                  Intenta nuevamente.
                </>
              )}
            </Text>
          </Box>
        </ModalBody>
        <ModalFooter justifyContent="center">
          <Button
            colorScheme="blue"
            onClick={handleButtonClick}
            display="flex"
            justifyContent="center"
            alignItems="center"
            borderRadius="5px"
            width="289.796px"
            height="36.224px"
            padding="6px 8px"
            backgroundColor="#74BF00"
          >
            {status === 'success' ? 'Entiendo' : 'Volver'}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default ChangePasswordPopup
